import qs from 'qs'
import To from 'await-to-js'
import Callback from '@/services/Callback'
import { wizStandardInstance } from './instance'

export default class DataModelService {
  // 获取模型列表
  static async getList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/MetricsDataModel?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 校验数据模型关联关系
  static async checkModel(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/MetricsDataModel/validate-data-model-association', payload)
    )
    return Callback(err, res)
  }
  // 根据模型关联关系获取数据维度
  static async getDataDimension(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/MetricsDataModel/get-data-dimension', payload)
    )
    return Callback(err, res)
  }
  // 验证维度类型变更
  static async validateDimensionTypeChange(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/MetricsDataModel/validate-dimension-type-change', payload)
    )
    return Callback(err, res)
  }
  // 新增模型
  static async addModel(payload) {
    const [err, res] = await To(wizStandardInstance.post('/api/std/MetricsDataModel', payload))
    return Callback(err, res)
  }
  // 获取模型详情
  static async getModelDetail(payload) {
    const [err, res] = await To(wizStandardInstance.get(`/api/std/MetricsDataModel/${payload}`))
    return Callback(err, res)
  }
  // 修改模型
  static async updateModel(id, payload) {
    const [err, res] = await To(wizStandardInstance.put(`/api/std/MetricsDataModel/${id}`, payload))
    return Callback(err, res)
  }
  // 删除模型
  static async deleteModel(payload) {
    const [err, res] = await To(wizStandardInstance.delete(`/api/std/MetricsDataModel/${payload}`))
    return Callback(err, res)
  }
  // 修改发布状态
  static async updatePublish(payload) {
    const [err, res] = await To(
      wizStandardInstance.put('/api/std/MetricsDataModel/update-publish', payload)
    )
    return Callback(err, res)
  }
  // 数据预览
  static async dataPreview(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/MetricsDataModel/data-preview', payload)
    )
    return Callback(err, res)
  }
  // 获取数据预览表头
  static async dataPreviewHeader(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/MetricsDataModel/data-preview-header?id=${payload}`)
    )
    return Callback(err, res)
  }
  // 是否存在依赖
  static async isExistDepend(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/MetricsDataModel/is-exist-depend?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
}
